import React, { createContext, useState, useMemo } from 'react';

type GlobalScanContextType = {
  image: Blob | undefined;
  setImage: React.Dispatch<React.SetStateAction<Blob | undefined>>;
  themeId: number;
  setThemeId: React.Dispatch<React.SetStateAction<number>>;
  projectId: number;
  setProjectId: React.Dispatch<React.SetStateAction<number>>;
  imageTaken: boolean;
  setImageTaken: React.Dispatch<React.SetStateAction<boolean>>;
  saveIsEditable: boolean;
  setSaveIsEditable: React.Dispatch<React.SetStateAction<boolean>>;
};

export const GlobalScanContext = createContext({} as GlobalScanContextType);

export default function GlobalScan({
  children,
}: {
  children: React.ReactNode;
}) {
  const [image, setImage] = useState<Blob>();
  const [themeId, setThemeId] = useState(0);
  const [projectId, setProjectId] = useState(0);
  const [imageTaken, setImageTaken] = useState(false);
  const [saveIsEditable, setSaveIsEditable] = useState(false);

  const value = useMemo(
    () => ({
      image,
      setImage,
      themeId,
      setThemeId,
      projectId,
      setProjectId,
      imageTaken,
      setImageTaken,
      saveIsEditable,
      setSaveIsEditable,
    }),
    [image, themeId, projectId, imageTaken, saveIsEditable]
  );

  return (
    <GlobalScanContext.Provider value={value}>
      {children}
    </GlobalScanContext.Provider>
  );
}
